import { Shark, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./password-reset.html";

import dashboardView from "../dashboard/dashboardView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import registerView from "../register/registerView";
import userManager from "../../controllers/userManager";

class PasswordResetView extends View {
	constructor() {
		super("passwordResetView");

		this.setTemplate(templateContent);
	}

	init () {
		this.addComponents([mainNavComponent]);

		Shark.set({
			passwordHints: [],
		});
	}

	inputField_keyupHandler (event) {
		if (event.keyCode === 13) {
			this.setNewPassword();
		}
	}

	// passwordField_inputHandler () {
	// 	const currUser = Shark.get("currUser");
	// 	// currUser.password = document.querySelector("#passwordField").value;
	// 	this.validatePassword();
	// 	document.querySelector("#passwordField").focus();
	// }

	// passwordConfirmField_inputHandler () {
	// 	const currUser = Shark.get("currUser");
	// 	// currUser.__passwordConfirm = document.querySelector("#passwordConfirmField").value;
	// 	this.validatePassword();
	// 	document.querySelector("#passwordConfirmField").focus();
	// }

	validatePassword () {
		const currUser = Shark.get("currUser");
		// currUser.password = document.querySelector("#passwordField").value;
		const validationErrors = currUser.validate("setNewPassword");
		
		Shark.set({
			passwordHints: validationErrors,
		});
		Shark.render();
	}

	setNewPassword () {
		const currUser = Shark.get("currUser");
		const validationErrors = currUser.validate("setNewPassword");

		console.log(validationErrors, currUser);
		if (validationErrors.length === 0) {
			document.querySelector("#setNewPasswordBtn").disabled = true;
			document.querySelector("#setNewPasswordBtn").innerHTML = "Attendi...";

			userManager.setNewPassword(currUser)
			.then(setNewPasswordResponse => {
				console.log({setNewPasswordResponse});
				if (setNewPasswordResponse.data.status === "success") {
					Shark.set({
						confirmSent: true,
					});

					Shark.render();
				}
				else {
					document.querySelector("#setNewPasswordBtn").disabled = false;
					document.querySelector("#setNewPasswordBtn").innerHTML = "Invia richiesta";
					alert("Attenzione, si è verificato un errore!\n\nProbabilmente il link che hai usato non è più valido, prova a ripetere la procedura di recupero password.");
				}
			});
		}
		else {
			Shark.set({
				passwordHints: validationErrors,
			});
			Shark.render();
		}
	}

	setNewPasswordBtn_clickHandler () {
		this.setNewPassword();
	}

	setNewPasswordForm_submitHandler (event) {
		event.preventDefault();
		event.stopPropagation();

		return false;
	}
}

const passwordResetView = new PasswordResetView();

Shark.registerView(passwordResetView);

export default passwordResetView;
